import Vue from '../consts/vue'
import PortalVue from 'portal-vue'

Vue.use(PortalVue)
